<template>
  <div>
    <div>
      <div class="has-margin-top-7 has-margin-bottom-7">
        <div class="is-flex-space-between has-text-grey is-size-7">
          <span>{{ forecastStart }}</span>
          <span>{{ forecastHalf }}</span>
          <span>{{ forecastEnd }}</span>
        </div>
        <div class="is-size-7-mobile">
          <ul class="rain-forecast">
            <li v-for="(rainForecast) in rainForecasts" :key="rainForecast.id" :title="rainForecast.title" class="rain-forecast-item has-text-centered" :class="`is-rain-${rainForecast.value}`">
              <i :class="getRainIconClass(rainForecast.value)" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('data')

export default {
  props: {
    equipment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // global
    states: function () {
      const states = []
      this.equipment.states.forEach((stateId) => states.push(this.getStateById(stateId)))
      return states.filter((state) => state.isVisible).sort((a, b) => a.order - b.order)
    },
    ...mapGetters(['getStateById']),
    // rainForecast
    rainForecasts: function () {
      const rainForecasts = []
      const forecastDate = this.getStateValueByLogicalId('forecastDate')
      for (let i = 0; i < 12; i++) {
        const state = this.states.find((state) => state.logicalId === 'prev' + i)
        const title = this.getFormattedTimeFromHourMinuteText(forecastDate, i * 5) + ' à ' + this.getFormattedTimeFromHourMinuteText(forecastDate, (i + 1) * 5)
        rainForecasts.push({ id: state.logicalId, title, value: state.currentValue })
      }
      return rainForecasts
    },
    forecastStart: function () { return this.getFormattedTimeFromHourMinuteText(this.getStateValueByLogicalId('forecastDate')) },
    forecastHalf: function () { return this.getFormattedTimeFromHourMinuteText(this.getStateValueByLogicalId('forecastDate'), 30) },
    forecastEnd: function () { return this.getFormattedTimeFromHourMinuteText(this.getStateValueByLogicalId('forecastDate'), 60) },
  },
  methods: {
    // global
    getStateValueByLogicalId (logicalId) {
      const state = this.states.find((state) => state.logicalId === logicalId)
      if (!state) {
        return
      }
      return state.currentValue || null
    },
    getRainIconClass (value) {
      switch (parseInt(value)) {
        case 1:
          return 'fa fa-cloud-sun'
        case 2:
        case 3:
          return 'fa fa-cloud-rain'
        case 4:
          return 'fa fa-cloud-showers-heavy'
        default:
          return 'fa fa-question'
      }
    },
    getFormattedTimeFromHourMinuteText (text, minutesToAdd = 0) {
      if (!text) {
        return ''
      }
      return this.$moment(text).add(minutesToAdd, 'minutes').format('LT')
    },
  },
}
</script>
<style scoped>
.rain-forecast {
  display: flex;
}
.rain-forecast .rain-forecast-item {
  flex-grow: 1;
  width: 100%;
}
.rain-forecast-item:first-child {
  border-radius: 290486px 0 0 290486px;
}
.rain-forecast .rain-forecast-item:last-child {
  border-radius: 0 290486px 290486px 0;
}
.is-rain-1 {
  color: hsl(48, 100%, 40%);
  background-color: hsl(48, 100%, 67%);
}
.is-rain-2 {
  color: hsl(204, 86%, 40%);
  background-color: hsl(204, 86%, 75%);
}
.is-rain-3 {
  color: hsl(204, 86%, 32%);
  background-color: hsl(204, 86%, 64%);
}
.is-rain-4 {
  color: hsl(204, 86%, 24%);
  background-color: hsl(204, 86%, 53%);
}
</style>
